import DashboardComponentWrapper from "../../components/DashboardComponentWrapper";
import { useNavigate, useSearchParams } from "react-router-dom";
import { images, icons } from "../../assets";
import { useCallback, useEffect, useState } from "react";
import { createEmployer, getEmployers, handleSelectEmployer, removeEmployerReq, updateEmployerReq } from "../../actions/employer";
import { useAppSelector } from "../../app/hooks";
import Modal from "../../components/Modal";
import Input, { CustomMultiSelect } from "../../components/Input";
import { getUsers } from "../../actions/users";
import './index.scss';
import { jwtDecode } from "jwt-decode";

const EmployerList = () => {
    const employersList = useAppSelector((state) => state.employers.employers);
    const [loading, setLoading] = useState(employersList.length === 0);
    const [users, setUsers] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [confirmDelete, showConfirmDelete] = useState(false);
    const navigate = useNavigate();

    const [searchParams, setParams] = useSearchParams();
    
    useEffect(() => {
        if (searchParams.get('open_form') === 'true') {
            setShowAddForm(true);
            setParams();
        }
    }, [searchParams]);
    
    const [data, setData] = useState({
        name: "",
        description: "",
        employerCode: "",
        emailAddress: "",
        includeInScheduleNotification: false,
        users: [],
    });
    const [employer, setEmployer] = useState({});

    const handleChange = useCallback((name: string, value: string) => {
        setData((prevState) => ({
          ...prevState,
          [name]: value
        }));
    }, []);

    useEffect(() => {
        getUsers((resp) => {
            setUsers(resp.data);
        }, true)
    }, []);
    useEffect(() => {
        employersList.length === 0 && getEmployers(() => {
            setLoading(false)
        });
    }, []);

    const handleAddEmployer = (event) => {
        event.preventDefault();
        createEmployer(data, (data) => {
            getEmployers(() => {});
            setShowAddForm(false);
            setData({
                name: "",
                description: "",
                employerCode: "",
                emailAddress: "",
                includeInScheduleNotification: false,
                users: [],
            });
        });
    }

    const editEmployerHandler = (event) => {
        event.preventDefault();
        updateEmployerReq({...employer, ...data}, (data) => {
            getEmployers(() => {});
            setShowAddForm(false);
            setIsEdit(false);
            setData({
                name: "",
                description: "",
                employerCode: "",
                emailAddress: "",
                includeInScheduleNotification: false,
                users: [],
            });
        });
    }

    const getUserOptions = users.map((user: any) => {
        return {
            label: `${user.firstName} ${user.lastName} [${user.roles}]`,
            value: user.userId
        }
    });

    const handleDeleteEmployer = (employer) => {
        setEmployer(employer);
        showConfirmDelete(true)
    }

    const handleEditEmployer = (employer) => {
        setEmployer(employer);
        setData({
            name: employer.name,
            description: employer.description,
            employerCode: employer.employerCode,
            emailAddress: employer.emailAddress,
            includeInScheduleNotification: employer.includeInScheduleNotification,
            users: employer.users.map((itm) => itm.userId),
        });
        setShowAddForm(true);
        setIsEdit(true);
    }

    const getDefaultEmployer = () => {
        const token = localStorage.getItem('tazat');
        if (!token) return {name: ''}
        const decoded = jwtDecode(token);
        return {
          // employerCode: '',
          // @ts-ignore
          name: JSON.parse(decoded?.Profile).CompanyName
        }
    }

    return (
        <DashboardComponentWrapper
            subTitle={``}
            pageDetails=""
        >
            <>
                <div className="w-full flex flex-col justify-start items-center pb-10 min-h-screen">
                    <div className="mb-6">
                        <p className="text-4xl">Select employer.</p>
                        <p className="text-lg my-2">Which employer would you like to remit pension for today?</p>
                    </div>
                    <div className="w-[90%] xl:w-[70%] my-6 flex flex-row flex-wrap items-center justify-center gap-6">
                        <div
                            onClick={() => setShowAddForm(true)}
                            className="cursor-pointer">
                            <div
                                className={`h-[200px] w-[300px] flex flex-col justify-between items-center p-8 rounded-md relative bg-[#0898a010]`}
                            >
                                <div className="flex flex-col justify-center items-center">
                                    <p className="text-xl capitalize">Are you remitting pension on behalf of more organizations?</p>
                                </div>
                                <button className="!w-fit px-5 bg-az-teal text-white rounded h-9 text-sm flex flex-row justify-center items-center capitalize">
                                    Add new Employer
                                    <svg className="ml-3" xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
                                        <path d="M14.2812 6.25977L1.15625 6.25977" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M8.9873 0.988374L14.2811 6.25937L8.9873 11.5312" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div
                            className="cursor-pointer relative employer-card">
                            <div
                                className={`h-[200px] w-[300px] flex flex-col justify-between items-start p-8 rounded-md relative`}
                                style={{
                                    backgroundColor: '#0898A01A',
                                }}
                            >
                                <div className="flex flex-col justify-start items-start">
                                    <p className="text-2xl capitalize w-full overflow-hidden h-9 text-left">Default Account</p>
                                    <p className="text-2xl capitalize">{getDefaultEmployer().name}</p>
                                </div>
                                <button
                                    onClick={() => {
                                        handleSelectEmployer({});
                                        navigate(`/dashboard/overview`);
                                    }}
                                    className="!w-fit pr-10 bg-az-teal text-white rounded h-9 !pl-4 text-sm flex flex-row justify-start items-center capitalize">
                                    Remit Pension
                                    <svg className="ml-3" xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
                                        <path d="M14.2812 6.25977L1.15625 6.25977" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M8.9873 0.988374L14.2811 6.25937L8.9873 11.5312" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        {
                            employersList?.map((itm, index) => (
                                <div
                                    key={`${itm.title}${index}`}
                                    className="cursor-pointer relative employer-card">
                                    <div className="action-btn absolute flex-row gap-2 right-4 top-4 z-50">
                                        <button className="cursor-pointer" onClick={(e) => handleDeleteEmployer(itm)}>
                                            <img className="w-5 h-5" src={icons.delete} alt="" />
                                        </button>
                                        <button className="cursor-pointer" onClick={(e) => handleEditEmployer(itm)}>
                                            <img className="w-5 h-5" src={icons.editIcon} alt="" />
                                        </button>
                                    </div>
                                    <div
                                        className={`h-[200px] w-[300px] flex flex-col justify-between items-start p-8 rounded-md relative`}
                                        style={{
                                            backgroundColor: '#0898A01A',
                                        }}
                                        title={itm.description}
                                    >
                                        <div className="flex flex-col justify-start items-start">
                                            <p title={itm.name} className="text-2xl capitalize w-full overflow-hidden h-9 text-left">{itm.name}</p>
                                            <p className="text-2xl capitalize">{itm.employerCode}</p>
                                        </div>
                                        <button
                                            onClick={() => {
                                                handleSelectEmployer(itm);
                                                navigate(`/dashboard/overview`);
                                            }}
                                            className="!w-fit pr-10 bg-az-teal text-white rounded h-9 !pl-4 text-sm flex flex-row justify-start items-center capitalize">
                                            Remit Pension
                                            <svg className="ml-3" xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
                                                <path d="M14.2812 6.25977L1.15625 6.25977" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8.9873 0.988374L14.2811 6.25937L8.9873 11.5312" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                <Modal
                    onClose={() => setShowAddForm(false)}
                    open={showAddForm}
                    title={isEdit ? 'Edit Employer' : 'Add new Employer'}
                    overrideStyle={{
                        height: 'fit-content',
                        maxHeight: '75vh'
                    }}
                >
                        <form onSubmit={isEdit ? editEmployerHandler : handleAddEmployer} className="w-full flex flex-col justify-start items-center h-full">
                            <div className="w-full flex flex-row justify-between">
                                <div className="w-[48%] flex flex-row justify-between">
                                    <Input
                                        name={"employerCode"}
                                        value={data.employerCode}
                                        label="Employer code"
                                        required
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="w-[48%] flex flex-row justify-between">
                                    <Input
                                        name={"name"}
                                        value={data.name}
                                        label="Employer name"
                                        required
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="w-full flex flex-row justify-between">
                                <Input
                                    name={"emailAddress"}
                                    value={data.emailAddress}
                                    label="Email Address"
                                    required
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="w-full flex flex-col justify-between">
                                <label htmlFor="" className="w-full text-[#66676D]">Add users</label>
                                <CustomMultiSelect
                                    data={getUserOptions} 
                                    // @ts-ignore
                                    value={data.users.map((user) => {
                                        const obj = getUserOptions.find((itm) => itm.value === user);
                                        return obj;
                                    }).filter((itm) => itm)}
                                    onChange={(name, value) => {
                                        handleChange(name, value)
                                    }}
                                    name="users"
                                />
                            </div>
                            <div className="w-full flex flex-row justify-between">
                                <Input
                                    name={"description"}
                                    value={data.description}
                                    label="Description"
                                    onChange={handleChange}
                                    maxLength={145}
                                />
                            </div>
                            <div className="w-full flex flex-row justify-start items-center mb-4">
                                <input 
                                    type="checkbox" 
                                    // @ts-ignore
                                    onChange={(event) => handleChange('includeInScheduleNotification', event.target.checked)}
                                    checked={data.includeInScheduleNotification}
                                    className="!w-4 !h-4 mr-2 !mb-0" name="includeInScheduleNotification" id="" />
                                <label htmlFor="" className="w-full text-[#66676D]">Include in Schedule Notification</label>
                            </div>
                            <div className='flex flex-row justify-around items-center w-full'>
                                <button type="button" onClick={() => {
                                    setShowAddForm(false);
                                    setData({
                                        name: "",
                                        description: "",
                                        employerCode: "",
                                        emailAddress: "",
                                        includeInScheduleNotification: false,
                                        users: [],
                                    });
                                }} className='border border-az-teal text-az-teal px-4 py-2 w-[48%]'>Cancel</button>
                                <button className='text-white bg-az-teal px-4 py-2 w-[48%]'>Submit</button>
                            </div>
                        </form>
                </Modal>
                <Modal
                    onClose={() => showConfirmDelete(false)}
                    open={confirmDelete}
                    title={'Confirm Delete Action'}
                    overrideStyle={{
                        height: '230px',
                    }}
                >
                        <div className="w-full flex flex-col justify-start items-center h-full">
                            <p className="text-center">Are you sure you want to delete this employer?</p>
                            <p className="text-center">You will not be able to access all employer data after deletion</p>
                            <div className='flex flex-row justify-around items-center w-full mt-5'>
                                <button onClick={() => showConfirmDelete(false)} className='border border-az-teal text-az-teal px-4 py-2 w-[48%]'>No</button>
                                <button onClick={() => {
                                    // @ts-ignore
                                    removeEmployerReq(employer?.id, () => {
                                        showConfirmDelete(false);
                                        getEmployers(() => {});
                                    })
                                }} className='text-white bg-az-teal px-4 py-2 w-[48%]'>Yes</button>
                            </div>
                        </div>
                </Modal>
            </>
        </DashboardComponentWrapper>
    )
};

export default EmployerList;
